import { Typography, Box, Paper } from '@mui/material';
import React, { useState } from 'react';
import SurveyStepper from './SurveyStepper';
import { getQuestions } from './surveyData';
import LikertQuestion from './LikertQuestion';
import OppositeQuestion from './OppositeQuestion';
import MultipleChoice from './MultipleChoice';
import TextQuestion from './TextQuestion';
import SingleChoice from './SingleChoice';
import MultiAndFree from './MultiAndFree';
import SingleAndFilter from './SingleAndFilter';
import FinishModal from './FinishModal';
import { grey } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';

const moveUp = () => {
    window.scrollTo(0, 105)
}

export default function SimpleSurvey(props) {

    const {t, i18n} = useTranslation()

    const questions = getQuestions(t);
    const titles=Object.keys(questions);

    const activePart = props.activePart;
    const setActivePart = props.setActivePart;

    const [finishModalOpen, setFinishModalOpen] = useState(false);

    const handleModalClose = () => {
        setFinishModalOpen(false);
    }

    const handleModalOpen = () => {
        setFinishModalOpen(true);
    }
    
    const handleFinish = (changeAllowed, timeAllowed) => {
        props.finishSurvey(changeAllowed, timeAllowed, i18n.language);
        handleModalClose();
    }

    const incrementPage = () => {
        moveUp();
        if (activePart < titles.length) {
            setActivePart(activePart + 1);
        }
    }

    const decrementPage = () => {
        moveUp();
        if (activePart > 0) {
            setActivePart(activePart - 1);
        }
    }

    const renderAllQuestions = () => {

        const shownQuestions = [];
        let even = true

        const bgColor = (isEven) => isEven && grey[200]

        for (let question of questions[titles[activePart]].questions) {
            if (question.type === "opposite") {
                shownQuestions.push(
                <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                    <OppositeQuestion left={question.left} right={question.right} key={question.id} surveyUserData={props.surveyUserData}
                    updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}/>
                </Paper>
                )
            } else if (question.type === "likert") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <LikertQuestion question={question.question} key={question.id} surveyUserData={props.surveyUserData}
                            updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}
                        />
                    </Paper>
                )
            } else if (question.type === "multiple") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <MultipleChoice question={question.question} key={question.id} choices={question.choices} surveyUserData={props.surveyUserData}
                        updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}
                        />
                    </Paper>
                )
            } else if (question.type === "multi_free") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <MultiAndFree question={question.question} key={question.id} choices={question.choices} surveyUserData={props.surveyUserData}
                        updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}

                        />
                    </Paper>
                )
            } else if (question.type === "text") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <TextQuestion question={question.question} key={question.id} surveyUserData={props.surveyUserData}
                        updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}

                        />
                    </Paper>
                )
            } else if (question.type === "single") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <SingleChoice question={question.question} key={question.id} choices={question.choices} surveyUserData={props.surveyUserData}
                        updateSurveyData={props.updateSurveyData} questionId={question.id} updateChangeBehaviour={props.updateChangeBehaviour}

                        />
                    </Paper>
                )
            } else if (question.type === "single_filter") {
                shownQuestions.push(
                    <Paper sx={{backgroundColor: bgColor(even), width: "100%", mb: 1, p: 1}}>
                        <SingleAndFilter question={question.question} key={question.id} choices={question.choices} surveyUserData={props.surveyUserData}
                        updateSurveyData={props.updateSurveyData} questionId={question.id} filtered={question.filtered} updateChangeBehaviour={props.updateChangeBehaviour}
                        />
                    </Paper>
                )
            } else {
                shownQuestions.push(null);
            }
            even = !even;
        }


        return shownQuestions;
    }

    return(
        <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", m: 2, maxWidth: "35rem"}}>
            <Typography sx={{mb: 2}} variant="h2">{titles[activePart]}</Typography>
            {questions[titles[activePart]].text}
            {renderAllQuestions()}
            <SurveyStepper length={titles.length} currentPage={activePart} incrementPage={incrementPage} decrementPage={decrementPage}
                onFinish={handleFinish} isFinished={props.isFinished} handleModalOpen={handleModalOpen}
            />
            <FinishModal open={finishModalOpen} close={handleModalClose} handleFinish={handleFinish}/>
        </Box>
    )
}



